<div class="page-layout blank fullwidth p-12 payments-page-wrapper">
    <div class="page">
        <div class="heading">
            <h2>Payments</h2>
            <div class="avg-days-and-class">
             <div class="avg-day" *ngIf="historyData?.length>0 && !(selectedTab === 'credit')">
            <p>⏱ Avg. Days to Pay: {{ avgDaysToPay }} {{ avgDaysToPay === 1 || 0 ? 'day' : 'days' }}</p>
        </div>
            <div class="above-amount">
                <div class="amount" *ngIf="selectedTab === 'pending'">
                    <img src ="../../../../assets/images/payment-collection-header-icon.png">
                    <p>Total Payment Due:</p>
                    <p class="due-amont">₹{{pendingAmount | number:'1.2-2'}}</p>
                </div>
            </div>
            <div class="amount" *ngIf="selectedTab === 'paid'">
                <img src ="../../../../assets/images/payment-collection-header-icon.png">
                <p>Total Paid Amount:</p>
                <p class="due-amont">₹{{paidAmount | number:'1.2-2'}}</p>
                
            </div>
            <div class="amount" *ngIf="selectedTab === 'history'">
                <img src ="../../../../assets/images/payment-collection-header-icon.png">
                <p>Total Paid Amount:</p>
                <p class="due-amont">₹{{historyAmount | number:'1.2-2'}}</p>
                
            </div>
            <div class="amount" *ngIf="selectedTab === 'credit'">
                <img src ="../../../../assets/images/payment-collection-header-icon.png">
                <p>Total Credit Amount:</p>
                <p class="due-amont">₹{{creditAmount | number:'1.2-2'}}</p>
                
            </div>
            </div>
        </div>
       
        <div class="subpage">
            <div [ngClass]="isMobile? 'filterMobile' : 'filter'" *ngIf="!isMobile || isSidebarOpen">
            <div class="mobile-close">
            <i *ngIf="isMobile" (click)="sidecontainer()">arrow_back</i>
            <h3>Filters</h3>
            <i *ngIf="isMobile" (click)="sidecontainer()">close</i>
            </div>
            <!-- Amount Range Filter -->
            <div class="clear">
                <div *ngIf="selectedFilters.length > 0"  class="applied-filters">
                    <div class="clear">
                        <h4>Applied Filters</h4>
                        <div *ngIf="selectedFilters.length > 0"  (click)="resetFilters()" class="clear-filters-btn">
                            Clear Filters
                        </div>
                    </div>
                    <div *ngFor="let filter of selectedFilters" class="apply">
                    <span> {{ filter.label }}</span>
                    <mat-icon (click)="removeFilter(filter)" class="apply1">cancel</mat-icon>
                    </div>
                </div>
            </div>
            <div class="filter-block">
                <h4>Amount Range</h4>
                <div *ngFor="let option of filters.amountRange" class="value">
                <label>
                    <input
                    type="checkbox"
                    [checked]="option.checked"
                    (change)="toggleSelection('amountRange', option)" />
                    {{ option.label }}
                </label>
                </div>
            </div>

            <!-- Invoice Date Filter -->
            <div class="filter-block" *ngIf="selectedTab === 'pending' || selectedTab === 'paid' || selectedTab === 'history'">
                <h4>Invoice Date</h4>
                <div *ngFor="let option of filters.invoiceDate" class="value">
                <label>
                    <input
                    type="checkbox"
                    [checked]="option.checked"
                    (change)="toggleSelection('invoiceDate', option)" />
                    {{ option.label }}
                </label>
                </div>
            </div>

            
            <div *ngIf="selectedTab === 'paid' || selectedTab === 'history'" class="filter-block">
            <h4>Paid On Date</h4>
            <div *ngFor="let option of filters.paidOnDate" class="value">
                <label>
                <input
                    type="checkbox"
                    [checked]="option.checked"
                    (change)="toggleSelection('paidOnDate', option)"
                />
                {{ option.label }}
                </label>
            </div>
            </div>
            
            <!-- Due By Days (Radio) -->
            <div class="filter-block" *ngIf="selectedTab === 'pending' || selectedTab === 'paid' || selectedTab === 'history'">
                <h4  *ngIf="selectedTab === 'pending'">Due By Days</h4>
                <h4  *ngIf="selectedTab === 'paid' || selectedTab === 'history'">Paid In Days</h4>
                <div *ngFor="let option of filters.dueByDays" class="value">
                <label>
                    <input
                    type="radio"
                    name="dueByDays"
                    [checked]="option.checked"
                    (change)="toggleSelection('dueByDays', option)" />
                    {{ option.label }}
                </label>
                </div>
            </div>

            <!-- Invoice Numbers -->
        <div *ngIf="filters.invoiceNumbers[selectedTab]?.length" class="filter-block">
            <h4>Invoice Numbers</h4>
            <div class="invoice-id">
               <div *ngFor="let option of filters.invoiceNumbers[selectedTab]" class="value">
            <label>
                <input
                type="checkbox"
                [checked]="option.checked"
                (change)="toggleSelection('invoiceNumbers', option)"
                />
                {{ option.label }}
            </label>
            </div>

            </div>
            </div>
             <!-- ============credit-note-date======= -->
            <div class="filter-block" *ngIf="selectedTab === 'credit'">
                <h4>Credit Note Date</h4>
                <div *ngFor="let option of filters.creditNoteDate" class="value">
                    <label>
                    <input
                        type="checkbox"
                        [checked]="option.checked"
                        (change)="toggleSelection('creditNoteDate', option)" />
                    {{ option.label }}
                    </label>
                </div>
            </div>

             <!-- ============credit-note-Number======= -->

                <div class="filter-block" *ngIf="selectedTab === 'credit'">
                <h4>Credit Note Numbers</h4>
                <div class="invoice-id">
                    <div *ngFor="let option of filters.creditNoteNumbers" class="value">
                    <label>
                        <input
                        type="checkbox"
                        [checked]="option.checked"
                        (change)="toggleSelection('creditNoteNumbers', option)" />
                        {{ option.label }}
                    </label>
                    </div>
                </div>
                </div>

            <button class="apply-filter-btn" (click)="applyFilters()">Apply Filter</button>
            </div>
            <div class="main-sub">
                <div class="mobSearch">
                    <div class="search-bar-credit" (click)="toggleSearch()">
                    <i class="icon">search</i>

                    <div *ngIf="isInputVisible" class="SearchInputContainer" (click)="$event.stopPropagation()">
                        <input
                            [(ngModel)]="searchText"
                            class="SearchInput"
                            type="text"
                            placeholder="Type your search" />
                        <i class="cross" (click)="clearSearch($event)" >close</i>
                    </div>
                    <div class="scroll-text-container-credit">
                            <div *ngIf="selectedTab === 'credit' && !searchText && !isInputVisible" class="scroll-text">
                                <div id="animationText-1" class="SearchBarAnimationText">Search By "Credit Note Number"</div>
                                <div id="animationText-2" class="SearchBarAnimationText">Search By "Invoice Number"</div>
                                <div id="animationText-3" class="SearchBarAnimationText">Search By "Credit Note Amount"</div>
                            </div>
                            <div *ngIf="(selectedTab === 'pending' || selectedTab === 'paid') && !searchText && !isInputVisible" class="scroll-text">
                                <div id="animationText-1" class="SearchBarAnimationText">Search By "Registration Number"</div>
                                <div id="animationText-2" class="SearchBarAnimationText">Search By "Invoice Number"</div>
                                <div id="animationText-3" class="SearchBarAnimationText">Search By "Amount"</div>
                            </div>
                            <div *ngIf="selectedTab === 'history' && !searchText && !isInputVisible" class="scroll-text">
                                <div id="animationText-1" class="SearchBarAnimationText">Search By "Amount"</div>
                                <div id="animationText-2" class="SearchBarAnimationText">Search By "Payment Mode"</div>
                                <div id="animationText-3" class="SearchBarAnimationText">Search By "Tags"</div>
                            </div>
                        </div>
                    </div>



                    
                      <span  (click)="sidecontainer()" *ngIf="isMobile" class="filterslist">
                            <mat-icon>filter_list</mat-icon>
                            Filters
                        </span>
                </div>
                <div class="buttons" >
                <button class="request-button" 
                        [ngClass]="{'active': selectedTab === 'pending'}"
                        (click)="selectTab('pending')">Pending Invoices</button>
                <button class="request-button" 
                        [ngClass]="{'active': selectedTab === 'paid'}"
                        (click)="selectTab('paid')">Paid Invoices </button>
                <button class="request-button" 
                        [ngClass]="{'active': selectedTab === 'history'}"
                        (click)="selectTab('history')">Payment History</button>
                 <button *ngIf="creditNoteList.length > 0" class="request-button" 
                        [ngClass]="{'active': selectedTab === 'credit'}"
                        (click)="selectTab('credit')">Credit Note</button>
                </div>
                <div class="pay-buttons" *ngIf="selectedTab === 'pending'">
                    <button *ngIf="selectedTab === 'pending'" class="quick-pay-btn" (click)="openBottomSheet('Quick Pay',false)">
                        <img src="../../../../assets/images/payment-collection-flas-image.png">
                        <p>Quick Pay</p>
                    </button>

                    <button *ngIf="selectedTab === 'pending'" class="advance-pay-btn" (click)="openBottomSheet('Advance Pay', true)">
                        <img src="../../../../assets/images/payment-collection-camera-img.png">
                        <p>Advance Pay</p>
                    </button>       
                </div>
                <div class="payment-history-bulb" *ngIf="selectedTab === 'history'" >
                        <img src="../../../../assets/images/payment-collection-history-bulb.png">
                        <span>
                            Tip: You can now see which invoices have been cleared against each payment made.
                        </span>
                </div>

                <div *ngIf="selectedTab === 'pending'" class="pending">
                    <div class="head">
                        <h3 class="headingInvoices"><strong>Pending Invoices</strong></h3>
                        <div class="custom-bottom-header-top">
                            <div class="select-all">Select All</div>
                            <label class="custom-checkbox-wrapper">
                            <input type="checkbox" [(ngModel)]="selectAll" (change)="toggleSelectAll()" class="hidden-checkbox">
                            <span class="custom-checkbox"></span>
                            </label>
                        </div>
                    </div>

                    <div class="payment-card" *ngFor="let payment of filteredInvoices;let i = index">
                        <div class="card-top">
                            <div class="details">
                            <div class="header-top-row">
                                <div class="order-icon">
                                 <label class="custom-checkbox-wrapper">
                                    <input type="checkbox" [(ngModel)]="payment.selected" (change)="checkboxChange(payment)" class="hidden-checkbox">
                                    <span class="custom-checkbox"></span>
                                </label>
                                </div>
                                <div class="details-col-with-checkbox">
                                    <div  class="invoice-num-and-rupees">
                                        <div class="payment-id">{{ payment.invoiceNumber }}</div>
                                        <div class="mobile">₹{{ payment.balance }}</div>
                                    </div>
                                <div class="card-bottom">
                                    <div class="calendoricon-user">
                                        <div class="img-invoice">
                                             <mat-icon class="calendar_today">calendar_today</mat-icon>
                                            <span>{{ payment.date | date:'dd MMM yyyy'}} </span>
                                        </div>
                                        <p [ngClass]="getDueDayColor(payment)">{{ payment.dueDays }}</p>
                                    </div>
                                </div>
                                </div>
                            </div>

                            </div>
                        </div>

                        <div class="footer">
                            <div class="footer-span-morevert">
                                <div class="paymnt-date-and-reg-no">
                                    <span> Due date: {{ payment.dueDate | date:'dd MMM yyyy'}} </span> 
                                    <span *ngIf="payment.registrationNumber">Reg.No: {{ payment.registrationNumber}} </span>
                                </div>
                                <div class="more_vert" (click)="sideShow($event,i)">
                                        <i>more_vert</i>

                                        <div class="overlay" [class.visible]="openSideShow" (click)="closePopup()" *ngIf="selectedInvoiceIndex === i"></div>

                                        <ul class="openSideShow" *ngIf="openSideShow">
                                            
                                            <!-- View Payment Due Details with Breakdown on Hover -->
                                            <div class="hover-container" *ngIf="selectedInvoiceIndex === i">
                                            <li 
                                                (mouseenter)="setBreakdownIndex(i)" 
                                                (mouseleave)="clearBreakdownIndex(i)"
                                                (click)="$event.stopPropagation()"
                                            >
                                                <i class="material-icons">insert_drive_file</i> View Payment Due Details
                                            </li>

                                            <div class="payment-due-card" *ngIf="activeBreakdownIndex === i"> 
                                                <div class="title">Payment Due Breakdown</div>
                                                <div class="rows-header">
                                                    <div class="row1">
                                                    <span>Total Invoice Amount</span>
                                                    <span>₹{{ payment.total || 0 }}</span>
                                                    </div>
                                                     <div class="row2">
                                                        <span>Total Credit Note Amount</span>
                                                        <span>- ₹{{ payment.creditNoteTotal || 0 }}</span>
                                                    </div>
                                                </div>
                                                <div class="row-total">
                                                <span>Total Payment Due Amount</span>
                                                <span>₹{{ payment.totalPaymentDueAmount || 0 }}</span>
                                                </div>
                                            </div>
                                            </div>

                                            <!-- Other Options (make sure they clear the card when hovered or clicked) -->
                                            <li 
                                            (mouseenter)="clearBreakdownIndex(i)" 
                                            (click)="openInvoiceUrl(payment.invoiceUrl)" 
                                            *ngIf="selectedInvoiceIndex === i"
                                            >
                                            <img src="../../../../assets/images/download.png" class="download-icon" alt=""> Download Invoice
                                            </li>

                                            <li 
                                                *ngIf="payment.creditNotes?.length > 0 && payment.creditNoteIdAndNumber?.length>0 && selectedInvoiceIndex === i"
                                                (mouseenter)="clearBreakdownIndex(i)" 
                                                (click)="downloadCreditNote(payment)">
                                                <img src="../../../../assets/images/download.png" class="download-icon" alt="">
                                                Download Credit Note
                                            </li>



                                            <li 
                                            (mouseenter)="clearBreakdownIndex(i)" 
                                            (click)="shareOnWhatsApp(payment)" 
                                            *ngIf="selectedInvoiceIndex === i"
                                            >
                                            <i class="material-icons">share</i> Share Payment Link
                                            </li>
                                        </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="custom-bottom-bar" *ngIf="bootomOpen">
                        <div class="custom-bottom-header">
                            <label class="custom-checkbox-wrapper">
                            <input type="checkbox" [(ngModel)]="selectAll" (change)="toggleSelectAll()" class="hidden-checkbox">
                            <span class="custom-checkbox"></span>
                            <div class="select-all">Select All</div>
                            </label>
                            <div class="invoices-selected">{{ selectedCount }} {{ selectedCount === 1 ? 'Invoice' : 'Invoices' }} Selected</div>
                        </div>

                        <button class="custom-pay-button" (click)="proceedToPay()" *ngIf="!(roleType=='autoverse_employee')">
                            Pay Selected (₹{{ amount | number: '1.2-2' }})
                        </button>
                        <button class="custom-pay-button" (click)="shareSelectedInvoices()" *ngIf="roleType=='autoverse_employee'">Share Payment Link (₹{{ amount | number: '1.2-2' }})</button>

                    </div>
                </div>
                <div *ngIf="selectedTab === 'paid'" class="pending">
                    <h3 class="headingInvoices"><strong>Paid Invoices</strong></h3>
                    <div class="payment-card" *ngFor="let payment of filteredInvoices;let i = index">
                        <div class="card-top">
                            <div class="details">
                            <div class="header-top-row">
                                <div class="details-col">
                                    <div  class="invoice-num-and-rupees">
                                        <div class="payment-id">{{ payment.invoiceNumber }}</div>
                                        <div class="mobile">₹{{ payment.total }}</div>
                                    </div>
                                        <div class="card-bottom">
                                            <div class="calendoricon-user">
                                                <div class="img-invoice">
                                                     <mat-icon class="calendar_today" >calendar_today</mat-icon>
                                                    <div class="user">{{ payment.date | date:'dd MMM yyyy'}}</div>
                                                </div>
                                                <p [ngClass]="getPaidDayColor(payment)" class="m-0"> Paid in {{ getDaysSince(payment.date, payment.lastPaymentDate) }} day</p>
                                            </div>
                                        </div>
                                </div>
                            </div>
                            </div>
                        </div>

                        <div class="footer-paid">
                              <div class="more-vrt-pymnt-date">
                                <div>
                                    <div *ngIf="!shouldShowOnlyDueDate(payment)" class="text-muted">
                                    Payment date: {{ payment.lastPaymentDate | date:'dd MMM yyyy'}}
                                    </div>
                                        <div class="reg-due-block">
                                        <span class="text-muted" *ngIf="!shouldShowOnlyDueDate(payment) && payment.registrationNumber">
                                            Reg.No: {{ payment.registrationNumber }}
                                        </span>
                                        <span class="text-muted" *ngIf="shouldShowOnlyDueDate(payment)">
                                            Due date: {{ payment.dueDate | date:'dd MMM yyyy' }}
                                        </span>
                                    </div>
                                </div>
                                <div class="more_vert" (click)="sideShow($event,i)">
                                            <i>more_vert</i>
                                        <div class="overlay" [class.visible]="openSideShow" (click)="closePopup()" *ngIf="selectedInvoiceIndex === i"></div>
                                        <ul class="openSideShow" *ngIf="openSideShow">
                                        <li (click)="openInvoiceUrl(payment.invoiceUrl)"  *ngIf="selectedInvoiceIndex === i">
                                            <img src="../../../../assets/images/download.png" class="li-download-icon"  alt="">
                                            Download Invoice
                                        </li>
                                         <li 
                                                *ngIf="payment.creditNotes?.length > 0 && selectedInvoiceIndex === i"
                                                (mouseenter)="clearBreakdownIndex(i)" 
                                                (click)="downloadCreditNote(payment)">
                                                <img src="../../../../assets/images/download.png" class="download-icon" alt="">
                                                Download Credit Note
                                            </li>
                                        </ul>
                                        
                                </div>
                            </div>
                            <div>
                            
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedTab === 'history'" class="pending">
                    <h3 class="headingInvoices"><strong>Payment History</strong></h3>
                    <div class="invoice-payment-card" *ngFor="let payment of filteredInvoices">
                        <!-- Top Section -->
                        <div class="invoice-payment-header">
                            <div class="payment-icon-amount">
                                <div class="svg-svg">
                                    <img src="../../../../assets/images/svg.svg" class="payment-icon" />
                                </div>
                                <span class="payment-amount">₹{{ payment.amount?.toFixed(2) }}</span>
                            </div>
                        </div>


                        <!-- Payment Info -->
                        <div class="invoice-payment-details">
                            <div class="payment-date">Payment date: {{ payment.date | date:'MMM dd, yyyy' }}</div>
                            <div class="pymnt-md-brkdwn">
                                <div class="payment-mode">Payment Mode: {{ payment.paymentMode }}</div>
                                <!-- ▼ Toggle Icon -->
                                <mat-icon  *ngIf="payment.responsePaymentSettled?.length"
                                (click)="toggleBreakdown(payment.paymentNumber)">
                                {{ showBreakdown[payment.paymentNumber] ? 'expand_less' : 'expand_more' }}
                                </mat-icon>
                            </div>
                        </div>

                        <!-- Invoice Numbers Breakdown -->
                        <div
                            class="invoice-breakdown-section"
                            *ngIf="showBreakdown[payment.paymentNumber] && payment.responsePaymentSettled?.length">
                            <div class="breakdown-header">Payment Breakdown</div>
                            <div class="invoice-breakdown-row" *ngFor="let settled of payment.responsePaymentSettled">
                                <div class="invoice-breakdown-icon">
                                    <img src="../../../../assets/images/i.svg" />
                                </div>
                                <div class="invoice-breakdown-details">
                                    <div class="invoice-breakdown-amount">₹{{ settled.amount }}</div>
                                    <div class="invoice-breakdown-id">{{ settled.invoiceNumber }}</div>
                                </div>
                                <div class="invoice-breakdown-date">
                                    {{ settled.invoiceDate | date:'dd MMM yyyy' }}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div *ngIf="selectedTab === 'credit'" class="credit-note-section">
                    <h3 class="headingInvoices"><strong>Credit Notes</strong></h3>

                    <div class="credit-note-card" *ngFor="let credit of filteredInvoices; let i = index">
                        <div class="card-top">
                        <div class="details">
                            <div class="header-top-row">
                            <div class="details-col">
                                <div class="invoice-num-and-rupees">
                                <div class="payment-id"> {{ credit.creditNoteNumber || 'null' }} </div>
                                <div class="mobile"> ₹{{ credit.total || 'null' }} </div>
                                </div>

                                <div class="card-bottom-credit">
                                <div class="calendoricon-user">
                                    <div class="img-invoice">
                                        <div class="calndrcn-and-date">
                                             <mat-icon *ngIf = "credit.creditDate" class="calendar_today">calendar_today</mat-icon>
                                            <div class="user" *ngIf = "credit.creditDate" > {{ parseDateString(credit.creditDate) | date:'dd MMM yyyy' }} </div>
                                        </div>
                                    <p  class = "text-green m-0" [ngClass]="getCreditRemainingColor(credit)">
                                    Credit Remaining {{ credit.creditsRemaining || 'null' }}
                                    </p>
                                    </div>

                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>

                        <div class="footer-paid">
                        <div class="more-vrt-pymnt-date">
                            <div>
                            <div  *ngIf = "credit.invoiceNumber"  class="text-muted">Invoice No: {{ credit.invoiceNumber || 'null' }}</div>
                            <span class="text-muted">{{ getItemDescriptions(credit) }}</span>
                            </div>
                            <div class="more-vert-wrapper" >
                                <i class="material-icons" (click)="sideShow($event, i)">more_vert</i>

                                <!-- Overlay and menu together for better control -->
                                <div *ngIf="openSideShow && selectedInvoiceIndex === i" class="popup-container">
                                    <div class="overlay" (click)="closePopup()"></div>

                                    <ul class="custom-menu">
                                    <li (click)="viewCreditNote(credit)">
                                        <img src="../../../../assets/images/download.png" class="menu-icon" alt="Download" />
                                        Download Credit Note
                                    </li>

                                    </ul>
                                </div>
                            </div>

                        </div>
                        </div>
                    </div>
                </div>

                <ng-template #paymentSheet>
                <div class="payment-container">
                    <div class="payCancel">
                        <h3 class="title">{{ paymentTitle }}</h3>
                        <i (click)="closeBottomSheet()">cancel</i>
                    </div>
                    <form class="payment-form" #formRef="ngForm">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Amount</mat-label>
                    <input
                        matInput
                        required
                        type="number"
                        name="paymentAmount"
                        [(ngModel)]="paymentAmount"
                        (ngModelChange)="validateAmount()"
                        #amountModel="ngModel"
                        />


                   <mat-error *ngIf="amountModel.invalid && amountModel.touched">
                    <ng-container *ngIf="amountModel.errors?.required">
                        Amount is required
                    </ng-container>
                    <ng-container *ngIf="amountModel.errors?.min">
                        Amount must be greater than 0
                    </ng-container>
                    <ng-container *ngIf="amountModel.errors?.max">
                        Amount must be less than or equal to {{ pendingAmount | number:'1.2-2' }}
                    </ng-container>
                    </mat-error>

                </mat-form-field>

                    <mat-form-field appearance="outline" class="full-width description-field">
                        <mat-label>Description</mat-label>
                        <input matInput type="text" [(ngModel)]="description" name="description">
                        <mat-hint>Provide the description for payment</mat-hint>
                    </mat-form-field>

                    <button mat-flat-button  *ngIf="!(roleType=='autoverse_employee')" class="full-width pay-button" (click)="submitPayment(formRef)">Pay</button>
                    <button mat-flat-button  *ngIf="roleType=='autoverse_employee'" class="full-width pay-button" (click)="submitPayment(formRef)">Create Payment Link</button>
                    </form>
                </div>
                </ng-template>
                 <div class="overlay" [class.visible]="openSharePopup" (click)="closePopUp()" *ngIf="openSharePopup"></div>
                    <div class="popup-content" *ngIf="openSharePopup">
                    <i (click)="closePopUp()">cancel</i>
                    <img src="{{successIcon}}" alt="successIcon" class="success-icon">
                    <h3 >Payment Link Created!</h3>
                    <p class="order-label" >
                        <a href="{{paymentLink}}" target="_blank" class="payment-link">
                        {{paymentLink}}
                        </a> 
                    <mat-icon (click)="copyLink()" >file_copy</mat-icon>
                    </p>
                    <p class="date"><span>{{date |date:'dd MMM yyyy, h:mm a': 'GMT+1060'}}</span></p>
                    <p class="thank you">This Link will never expire</p>

                    <button class="goto-order"  (click)="shareLink()">
                        <i>share</i>
                        <p>Share Payment Link</p>
                    </button>
                    </div>
            </div>
        </div>
    </div>
</div> 
 